import {
  DeliveryOption,
  DeliveryOptions,
} from "./DeliveryOptions/DeliveryOptions";
import { ProductDeliveryReturns } from "./ProductDeliveryReturns/ProductDeliveryReturns";
import { ExtendedReturnsPolicy } from "./ExtendedReturnsPolicy/ExtendedReturnsPolicy";
import { ListItem } from "@/components/__shared__/ListItem/ListItem";
import { SEOFriendlyDrawer } from "../__shared__/SEOFriendlyDrawer/SEOFriendlyDrawer";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

export const PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME =
  "product-delivery-options";
export type ReturnsDateObj = Record<"year" | "month" | "date", number>;
export type Props = {
  deliveryOptions: DeliveryOption[];
  skuId: string;
  isAvailableToOrderOrPreorder: boolean;
  stockApiBaseUrl: string;
  stockApiKey: string;
  showExtendedReturnsMessaging: boolean;
  extendedReturnsDates: {
    startDate: string;
    endDate: string;
    deadlineDate: string;
  };
  isRetired: boolean;
  isInStoreOnly: boolean;
  isMeteredProduct?: boolean;
  isM2M: boolean;
  browsePageHierarchy: Array<{ categoryId: string }>;
  sellingProductType?: string;
  showOutletReturnMessage?: boolean;
  isBladedArticle?: boolean;
  returnsStartDate?: string;
  returnsEndDate?: string;
  showChristmasDeliveryMessaging: boolean;
};

export function ProductDeliveryOptionsSideDrawerUI({
  deliveryOptions,
  skuId,
  isAvailableToOrderOrPreorder,
  stockApiBaseUrl,
  stockApiKey,
  showExtendedReturnsMessaging,
  extendedReturnsDates,
  isInStoreOnly,
  isRetired,
  isMeteredProduct,
  isM2M,
  browsePageHierarchy,
  sellingProductType = "",
  showOutletReturnMessage = false,
  isBladedArticle = false,
  returnsStartDate,
  returnsEndDate,
  showChristmasDeliveryMessaging,
}: Props) {
  const [open, setOpen] = useState(false);

  if (isRetired) return null;
  if (isInStoreOnly) return null;

  return (
    <>
      <ListItem
        label="Delivery and returns"
        onClick={withSideDrawerAnalytics("Delivery & Returns", () =>
          setOpen(true),
        )}
        trailingIcon={<ChevronRight size="medium" />}
      />
      <SEOFriendlyDrawer
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        heading="Delivery and returns"
        primaryButtonText="Close"
      >
        {deliveryOptions.length > 0 && (
          <DeliveryOptions
            skuId={skuId}
            isAvailableToOrderOrPreorder={isAvailableToOrderOrPreorder}
            deliveryOptions={deliveryOptions}
            stockApiBaseUrl={stockApiBaseUrl}
            stockApiKey={stockApiKey}
          />
        )}
        <ProductDeliveryReturns
          browsePageHierarchy={browsePageHierarchy}
          sellingProductType={sellingProductType}
          showOutletReturnsMessage={showOutletReturnMessage}
          isBladedArticle={isBladedArticle}
          isM2M={isM2M}
          returnsStartDate={returnsStartDate}
          returnsEndDate={returnsEndDate}
          isMeteredProduct={isMeteredProduct}
          showChristmasDeliveryMessaging={showChristmasDeliveryMessaging}
        />
        {showExtendedReturnsMessaging && (
          <ExtendedReturnsPolicy {...extendedReturnsDates} />
        )}
      </SEOFriendlyDrawer>
    </>
  );
}
